<template>
  <bpb-input-text value="1" name="amount" type="number" :min="1" :max="999">
    <template #label>
      <a-label path="shop.amount" :is-visible="true">:</a-label>
    </template>
  </bpb-input-text>
</template>

<script>
export default {
  inject: ['formContext', 'shopContext'],
  computed: {
    id() {
      return this.shopContext.itemId;
    },
  },
};
</script>
